// index

let dt_clients = null;

export function index(){

    dt_clients = $('#clients_table').DataTable({
        ajax: {
            url: $('#clients_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_actions },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[1, 'asc']],
        pageLength: 50,
    });

}

function render_actions(data, type, row){
    const url_info = ($("#clients_table").attr('url_info') ?? '').replace('#', row.id);

    const actions =
    '<div class="btn-group" role="group">' +
    '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
    '</div>';

    return actions;
}

// show

let dt_orders = null;
let dt_order_references = null;

export function show(){

    if($('#orders_table').length){
        dt_orders = $('#orders_table').DataTable({
            ajax: {
                url: $('#orders_table').attr('url'),
            },
            columns: [
                { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_order_actions },
                { width: '80', data: 'date', orderable: true, searchable: false, render: datatables.render_date },
                { data: 'filename', orderable: true, searchable: true },
                { width: '80', data: 'status', orderable: false, searchable: false, defaultContent: '', render: render_order_status },
                { width: '120', data: 'updated_at', orderable: true, searchable: false, render: datatables.render_datetime }
            ],
            order: [[1, 'desc']],
            pageLength: 50,
        });
    }

    init_order_references_table();

}

function render_order_actions(data, type, row){
    const url_info = ($("#orders_table").attr('url_info') ?? '').replace('#', row.id);

    const actions =
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function render_order_status(data, type, row){

    switch(row.status){
        case 'analysis':
            return '<span class="badge bg-light">' + window.__('analizando') + '</span>';
        case 'creating':
            return '<span class="badge bg-light">' + window.__('preparación') + '</span>';
        case 'pending':
            return '<span class="badge bg-info">' + window.__('pendiente') + '</span>';
        case 'processing':
            return '<span class="badge bg-primary">' + window.__('en proceso') + '</span>';
        case 'completed':
            return '<span class="badge bg-success">' + window.__('completado') + '</span>';
        case 'failed':
            return '<span class="badge bg-danger">' + window.__('error') + '</span>';
    }

    return row.status + ' ???'; // unrecognized status

}

// create_order

export function create_order(){

    // Update exchange rate when currency changes
    $('select[name="currency"]').on('change', function(){
        const exchange_rate = $('select[name="currency"] option:selected').attr('exchange_rate') ?? 1;
        $('input[name="exchange_rate"]').val(exchange_rate);
    });

}

// match_columns

export function match_columns(){

    // Update exchange rate when currency changes
    $('select[name="currency"]').on('change', function(){
        const exchange_rate = $('select[name="currency"] option:selected').attr('exchange_rate') ?? 1;
        $('input[name="exchange_rate"]').val(exchange_rate);
    });

    // Enable/disable sheet configuration according to checkbox
    $('#match_columns_form').on('submit', validate_match_columns_form);

    // Highlight first row
    $('input.first-row').on('change', highlight_first_row).trigger('change');

    let status = $('#order_status').length ? $('#order_status').attr('status') : null;
    if(status == 'analysis'){
        setInterval(function(){
            $.ajax({
                url: $('#order_status').attr('url'),
                method: 'GET',
                success: function(response){
                    if(response.status != status){
                        location.reload();
                    }
                }
            });
        }, 5000);
    }

}

function validate_match_columns_form(e){
    e.preventDefault();

    let valid = true;

    if($('.sheet:checked').length == 0){
        window.messages.error(window.__('Debe seleccionar al menos una hoja para importar'));
        return false;
    }

    $('.sheet:checked').each(function(){

        const sheetIndex = $(this).attr('name').replace('sheet_', '');
        const sheetName = $(this).closest('.tab-pane').attr('sheet-name');

        const ean_columns = $('#sheet_' + sheetIndex + ' option[value="ean"]:selected').length;
        if(ean_columns == 0){
            window.messages.error(window.__('Debes seleccionar una columna para el código EAN en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        if(ean_columns > 1){
            window.messages.error(window.__('Sólo se puede asignar una columna para el código EAN en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        const name_columns = $('#sheet_' + sheetIndex + ' option[value="name"]:selected').length;
        if(name_columns == 0){
            window.messages.error(window.__('Debes seleccionar una columna para el nombre de producto en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        if(name_columns > 1){
            window.messages.error(window.__('Sólo se puede asignar una columna para el nombre de producto en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        const target_price_columns = $('#sheet_' + sheetIndex + ' option[value="target_price"]:selected').length;
        if(target_price_columns > 1){
            window.messages.error(window.__('Sólo se puede asignar una columna para el precio objetivo en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

    });

    return valid ? e.currentTarget.submit() : false;

}

function highlight_first_row(){

    const sheetIndex = $(this).attr('name').replace('sheet_', '').replace('_first_row', '');
    const first_row = parseInt($(this).val());

    $('#sheet_' + sheetIndex + ' .cell').removeClass('bg-success-light');
    for(let i = first_row; i <= 20; i++){
        $('#sheet_' + sheetIndex + ' .cell.row_' + i).addClass('bg-success-light');
    }

}

// show_order

let dt_import_results = null;

export function show_order(){

    // datatable import results (always present in the import tab)

    if($('#import_results_table').length){
        dt_import_results = $('#import_results_table').DataTable({
            ajax: {
                url: $('#import_results_table').attr('url'),
            },
            columns: [
                { width: 50, data: 'row', orderable: true, searchable: true },
                { width: 120, data: 'ean', orderable: false, searchable: true, defaultContent: '' },
                { data: 'status', orderable: false, searchable: false, defaultContent: '', render: render_import_result_status },
            ],
            order: [[0, 'asc']],
        });
    }

    init_order_references_table();

    let status = $('#order_status').length ? $('#order_status').attr('status') : null;
    if(
        status == 'pending'
        || status == 'processing'
    ){
        setInterval(function(){
            $.ajax({
                url: $('#order_status').attr('url'),
                method: 'GET',
                success: function(response){
                    if(response.status != status){
                        location.reload();
                    }
                }
            });
        }, 5000);
    }

}

function init_order_references_table(){

    if(!$('#order_references_table').length){
        return;
    }

    let providers = JSON.parse($('#providers_data').val());

    let columns = [];
    columns.push({ width: '50', data: null, orderable: false, searchable: false, class: 'actions', render: render_order_reference_actions });
    columns.push({ width: '100', data: 'ean', orderable: true, searchable: true });
    columns.push({ data: 'name', orderable: true, searchable: true });
    columns.push({ width: '80', data: 'target_price', orderable: true, searchable: false, class: 'text-right', defaultContent: '', render: datatables.render_price });
    for(let i = 0; i < providers.length; i++){
        columns.push({ width: '80', data: `provider_${providers[i].id}_offer`, orderable: false, searchable: false, class: 'text-right', render: render_provider_offer(providers[i]), defaultContent: '' });
    }
    columns.push({ width: '55', data: 'purchases[0].price', orderable: true, searchable: false, class: 'text-right', render: datatables.render_price });
    columns.push({ width: '45', data: 'purchases[0].date', orderable: true, searchable: false, class: 'text-right', render: datatables.render_date });
    columns.push({ width: '55', data: 'sales[0].price', orderable: true, searchable: false, class: 'text-right', render: datatables.render_price });
    columns.push({ width: '45', data: 'sales[0].date', orderable: true, searchable: false, class: 'text-right', render: datatables.render_date });
    columns.push({ width: '45', data: 'stock', orderable: true, searchable: true, defaultContent: '', class: 'text-right', render: render_stock });
    columns.push({ width: '60', data: 'units_per_box', orderable: false, searchable: false, defaultContent: '', class: 'text-right', render: render_stock });
    columns.push({ width: '60', data: 'boxes_per_pallet', orderable: false, searchable: false, defaultContent: '', class: 'text-right', render: render_stock });
    columns.push({ width: '55', data: 'best_price', orderable: false, searchable: false, defaultContent: '', render: datatables.render_price });
    columns.push({ width: '55', data: 'benefit', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: datatables.render_price });
    columns.push({ width: '55', data: 'margin', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: datatables.render_percentage });
    columns.push({ width: '80', data: 'best_provider_name', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_provider_names });
    columns.push({ width: '45', data: 'best_provider_stock', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_stock });
    columns.push({ width: '60', data: 'best_provider_units_per_box', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_units_per_box });
    columns.push({ width: '60', data: 'best_provider_units_per_pallet', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_units_per_pallet });
    columns.push({ width: '60', data: 'best_provider_boxes_per_pallet', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_boxes_per_pallet });
    columns.push({ width: '60', data: 'best_provider_min_order', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_min_order });
    columns.push({ width: '60', data: 'best_provider_max_order', orderable: false, searchable: false, class: 'text-right', defaultContent: '', render: render_best_providers_max_order });
    columns.push({ width: '60', data: 'best_provider_expiration', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_providers_expiration });
    columns.push({ width: '50', data: 'best_provider_language', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_providers_language });
    columns.push({ width: '80', data: 'best_provider_category', orderable: false, searchable: false, class: 'text-nowrap', defaultContent: '', render: render_best_providers_category });

    dt_order_references = $('#order_references_table').DataTable({
        ajax: {
            url: $('#order_references_table').attr('url'),
            type: 'POST',
        },
        responsive: false,
        columns: columns,
        order: [[2, 'asc']],
        pageLength: 25,
        lengthMenu: [25, 50, 100, 200, 500],
        dom: "<'row'<'col-sm-12 d-flex flex-column flex-sm-row justify-content-between align-items-center filters-container'l<'filters'f>>><'row'<'col-sm-12 overflow-x-scroll'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
    });

    dt_order_references.on('draw', function(e, settings){
        $('#order_references_table span.best_provider_offer').closest('td').addClass('bg-success-light');

        dt_order_references.rows().every(function(){
            let data = this.data();
            let $cells = $(this.node()).find('td');

            let target = parseFloat(data.target_price);
            if(isNaN(target)) return;

            let latestOrderDate = datatables.render_date(data.latest_order_date, 'display', data);
            if(latestOrderDate !== ''){
                $cells.eq(3).append('<div><small>' + latestOrderDate + '</small></div>');
            }

            let lastPurchase = data.purchases && data.purchases.length > 0 ? parseFloat(data.purchases[0].price) : NaN;
            let stock = parseFloat(data.stock ?? 0);

            let target_reached_by = [];
            if(!isNaN(lastPurchase) && target >= lastPurchase && stock > 0){
                target_reached_by.push(window.__('stock propio'));
            }

            for(let provider of providers){
                let offer = parseFloat(data[`provider_${provider.id}_offer`]);
                if(!isNaN(offer) && target >= offer){
                    target_reached_by.push(provider.name);
                }
            }

            if(target_reached_by.length > 0){
                $cells.eq(3).addClass('bg-success-light');
                $cells.eq(3).append('<div class="pt-2 text-left"><small>' + target_reached_by.join(', ') + '</small></div>');
            } else {
                $cells.eq(3).addClass('bg-danger-light');
            }
        });
    });

}

function render_import_result_status(data, type, row){

    let status = row.status.split(',');
    let badges = '';

    status.forEach(s => {
        switch(s.trim()){
            case 'reference_created':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('referencia creada') + '</span>';
                break;
            case 'order_created':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('producto vinculado') + '</span>';
                break;
            case 'invalid_ean':
                badges += '<span class="badge bg-warning me-1 mr-1">' + window.__('código no válido') + '</span>';
                break;
            case 'exception':
                badges += '<span class="badge bg-danger me-1 mr-1">' + window.__('error') + ': ' + row.exception + '</span>';
                break;
            case 'skipped':
                badges += '<span class="badge bg-light me-1 mr-1">' + window.__('no procesada: linea incompleta') + '</span>';
                break;
        }
    });

    return badges;

}

// comparative render functions

function render_order_reference_actions(data, type, row){
    const url_info = $("#order_references_table").attr('url_info') ?? '';
    if(url_info === '') return '';

    const info_url = url_info.replace('#', row.id);

    const actions =
        '<div class="btn-group pr-2" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + info_url + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function render_stock(data, type, row){

    if(
        data === null
        || data === undefined
    ){
        return '-';
    }

    return new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(data);

}

function render_best_provider_names(data, type, row){

    if(
        row.best_providers_name === undefined
        || row.best_providers_name.length === 0
    ){
        return '-';
    }

    return row.best_providers_name.map(function(name){
        return name != null && name != '' ? name : '-';
    }).join('<br>');

}

function render_best_providers_stock(data, type, row){

    if(
        row.best_providers_stock === undefined
        || row.best_providers_stock.length === 0
    ){
        return '-';
    }

    return row.best_providers_stock.map(function(stock){
        return stock != null && stock != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(stock) : '-';
    }).join('<br>');

}

function render_best_providers_units_per_box(data, type, row){

    if(
        row.best_providers_units_per_box === undefined
        || row.best_providers_units_per_box.length === 0
    ){
        return '-';
    }

    return row.best_providers_units_per_box.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_units_per_pallet(data, type, row){

    if(
        row.best_providers_units_per_pallet === undefined
        || row.best_providers_units_per_pallet.length === 0
    ){
        return '-';
    }

    return row.best_providers_units_per_pallet.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_boxes_per_pallet(data, type, row){

    if(
        row.best_providers_boxes_per_pallet === undefined
        || row.best_providers_boxes_per_pallet.length === 0
    ){
        return '-';
    }

    return row.best_providers_boxes_per_pallet.map(function(boxes){
        return boxes != null && boxes != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(boxes) : '-';
    }).join('<br>');

}

function render_best_providers_min_order(data, type, row){

    if(
        row.best_providers_min_order === undefined
        || row.best_providers_min_order.length === 0
    ){
        return '-';
    }

    return row.best_providers_min_order.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_max_order(data, type, row){

    if(
        row.best_providers_max_order === undefined
        || row.best_providers_max_order.length === 0
    ){
        return '-';
    }

    return row.best_providers_max_order.map(function(units){
        return units != null && units != '' ? new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(units) : '-';
    }).join('<br>');

}

function render_best_providers_expiration(data, type, row){

    if(
        row.best_providers_expiration === undefined
        || row.best_providers_expiration.length === 0
    ){
        return '-';
    }

    return row.best_providers_expiration.map(function(expiration){
        return expiration != null && expiration != '' ? expiration : '-';
    }).join('<br>');

}

function render_best_providers_language(data, type, row){

    if(
        row.best_providers_language === undefined
        || row.best_providers_language.length === 0
    ){
        return '-';
    }

    return row.best_providers_language.map(function(language){
        return language != null && language != '' ? language : '-';
    }).join('<br>');

}

function render_best_providers_category(data, type, row){

    if(
        row.best_providers_category === undefined
        || row.best_providers_category.length === 0
    ){
        return '-';
    }

    return row.best_providers_category.map(function(category){
        return category != null && category != '' ? category : '-';
    }).join('<br>');

}

let render_provider_offer = function(provider){
    return function(data, type, row){

        if(
            row.best_providers_id === undefined
            || row.best_providers_id.length === 0
            || data === null
            || data === ''
        ){
            return '-';
        }

        data = new Intl.NumberFormat(window._locale, { style: 'currency', currency: 'EUR', minimumFractionDigits: 3, maximumFractionDigits: 3, useGrouping: true }).format(data);

        if(row.best_providers_id.includes(provider.id)){
            return `<span class="best_provider_offer">${data}</span>`;
        }

        return data;

    }
}
